import React from 'react';
import PropTypes from 'prop-types';

export default class BasketErrors extends React.Component {
    render() {
        return this.props.errors.length > 0 ? (
            <div className="basket__errors">
                {this.props.errors.map((error, i) => <div key={i}>
                    {error.errorMessage} {error.productName ? `for ${error.productName}` : null} {error.audienceSubcategoryName ? `(${error.audienceSubcategoryName})` : null}
                </div>)}
            </div>
        ) : null;
    }
}

BasketErrors.propTypes = {
    errors: PropTypes.array.isRequired,
};
